import MarketingDisclaimer from './marketing-disclaimer';

export * from './marketing-disclaimer';
export default MarketingDisclaimer;
